import React, { useEffect, useRef, useState } from "react";
import { Card } from "react-bootstrap";
import { X } from "react-bootstrap-icons";
import PDFIcon from "../assets/img/pdf-logo.svg";
import uploadIcon from "../assets/img/Upload_Icon.svg";
import { Label } from "reactstrap";

interface fileUploadProps {
  disabled?: boolean;
  imageTitle: string;
  label: string;
  required?: boolean;
  value: { file: File | null; preview: string; type: string } | null;
  error?: boolean;
  errorMessage?: string;
  onChange?: (
    value: { file: File; preview: string; type: string } | null,
  ) => void;
}

const FileUpload: React.FC<fileUploadProps> = ({
  disabled = false,
  required = false,
  label,
  onChange,
  errorMessage,
  value,
}) => {
  const inputRef = useRef<any>(null);
  const [file, setFile] = useState<any>();
  const [hover, setHover] = useState(false);

  const fileToBase64 = (file: File): Promise<string> =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });

  const handleClick = () => {
    if (!disabled) inputRef.current.click();
  };

  const handleChange = async (e: any) => {
    const selectedFile = e.target.files?.[0];
    if (!selectedFile) return;

    const base64 = await fileToBase64(selectedFile);

    onChange?.({
      file: selectedFile,
      preview: base64,
      type: selectedFile?.type,
    });
    setFile({
      file: selectedFile,
      preview: base64,
      type: selectedFile?.type,
    });
  };

  const handleRemove = (e: any) => {
    e.stopPropagation();
    setFile(null);
    onChange?.(null);
  };

  useEffect(() => {
    if (value && value?.preview) {
      const prefix = value?.preview.startsWith("data:")
        ? ""
        : "data:image/png;base64,";

      setFile({
        file: null,
        preview: prefix + value?.preview,
        type: value?.type,
      });
    }
  }, [value]);

 const isValidFileType = (file: any) => {
   if (!file) return false;

   const allowedTypes = [
     "image/jpeg",
     "image/png",
     "image/gif",
     "image/webp",
     "image/bmp",
     "application/pdf",
   ];

   return allowedTypes.includes(file.type);
 };

  return (
    <div className="my-2">
      {label && (
        <Label className="mb-1 text-start search-label text-muted">
          {label}{" "}
          {required && (
            <span className="mx-1" style={{ color: "red" }}>
              *
            </span>
          )}
        </Label>
      )}
      {!file || !isValidFileType(file) ? (
        <Card
          onClick={handleClick}
          className="text-center border file-upload-input"
          style={{
            cursor: disabled ? "not-allowed" : "pointer",

            borderRadius: "16px",
            padding: "20px",
            opacity: disabled ? 0.6 : 1,
          }}
        >
          {/* Icon */}
          <div className="mb-2">
            <img
              src={uploadIcon}
              alt="upload"
              style={{ width: 30, opacity: 0.7 }}
            />
          </div>

          {/* Subtext */}
          <div style={{ fontSize: "13px", color: "#6c757d" }}>
            Tap to Upload File
          </div>
        </Card>
      ) : (
        <div style={{ position: "relative" }}>
          {file?.type === "application/pdf" ? (
            <div
              style={{
                position: "relative",
              }}
            >
              <img
                src={PDFIcon}
                alt="pdf-preview"
                style={{
                  width: "100%",
                  height: "100px",
                  objectFit: "contain",
                  borderRadius: "16px",
                  border: "1px solid #dee2e6",
                  background: "#fff",
                  padding: "10px",
                  opacity: disabled ? 0.5 : 1,
                }}
              />

              {/* File Name */}
              <div
                style={{
                  position: "absolute",
                  bottom: "6px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  fontSize: "11px",
                  fontWeight: 500,
                  color: "#495057",
                  background: "rgba(255,255,255,0.9)",
                  padding: "2px 8px",
                  borderRadius: "10px",
                  maxWidth: "90%",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {file?.name}
              </div>
            </div>
          ) : (
            <img
              src={file?.preview}
              alt="preview"
              style={{
                width: "100%",
                height: "100px",
                objectFit: "cover",
                borderRadius: "16px",
                border: "1px solid #dee2e6",
                opacity: disabled ? 0.5 : 1,
              }}
            />
          )}

          {!disabled && (
            <div
              onClick={handleRemove}
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
              style={{
                position: "absolute",
                top: "8px",
                right: "8px",
                background: hover ? "rgba(99, 90, 90, 0.8)" : "rgba(0,0,0,0.6)",
                borderRadius: "50%",
                width: "28px",
                height: "28px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                transition: "0.2s ease",
              }}
            >
              <X color="white" size={16} />
            </div>
          )}
        </div>
      )}

      <input
        type="file"
        ref={inputRef}
        onChange={handleChange}
        hidden
        accept="image/*,application/pdf"
        disabled={disabled}
      />
      {errorMessage && (
        <div className="search-helper-text mt-2">{errorMessage}</div>
      )}
    </div>
  );
};

export default FileUpload;
